/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ArchiveRequestBuilderRequestsMetadata, type ArchiveRequestBuilder } from './archive/index.js';
// @ts-ignore
import { CrewBriefingRequestBuilderNavigationMetadata, CrewBriefingRequestBuilderRequestsMetadata, type CrewBriefingRequestBuilder } from './crewBriefing/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Charter/{charter-id}
 */
export interface CharterItemRequestBuilder extends BaseRequestBuilder<CharterItemRequestBuilder> {
    /**
     * The Archive property
     */
    get archive(): ArchiveRequestBuilder;
    /**
     * The CrewBriefing property
     */
    get crewBriefing(): CrewBriefingRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CharterItemRequestBuilderUriTemplate = "{+baseurl}/Charter/{charter%2Did}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CharterItemRequestBuilderNavigationMetadata: Record<Exclude<keyof CharterItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    archive: {
        requestsMetadata: ArchiveRequestBuilderRequestsMetadata,
    },
    crewBriefing: {
        requestsMetadata: CrewBriefingRequestBuilderRequestsMetadata,
        navigationMetadata: CrewBriefingRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
